import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	for: {
		id: 'search-page.mercury.for',
		defaultMessage: 'for',
		description: 'The conjunction between a status and target date e.g. "On track for August"',
	},
	statusUpdateTitle: {
		id: 'search-page.mercury.focus-area-status-update.title',
		defaultMessage: 'Update for {focusAreaName}',
		description: 'Focus area status update title',
	},
});
